import React from "react";

const iFrameSource = "https://www.freeform.chat/tomo-credit-companion";
const iFrameTitle = "Tomo Credit Companion";

const TomoIqPage = () => {

  return (
    <div className="h-full overflow-hidden">
      <iframe
        src={iFrameSource}
        title={iFrameTitle}
        className="h-full w-full overflow-hidden bg-transparent"
      />
    </div>
  );
};

export default TomoIqPage;
